import { useSelector } from "react-redux";
import {
  getQuestionById,
  getQuestionsAndAnswers
} from "../../../../store/selectors";
import { useDispatch } from "react-redux";
import {
  QuestionIds,
  questionPresentationContent,
  questionRoutingLabels
} from "../../../../data/QuestionPresentation";
import { appraisalSlice } from "../../../../store/slices/Appraisal";
import { useNavigate } from "react-router-dom";
import { sendEvent, setAnalyticsLabel } from "../../../../helpers/analytics";

function useTaxi() {
  const QUESTION_ID = QuestionIds.TAXI;
  const NEXT_QUESTION_PATH = questionRoutingLabels[QuestionIds.EXTERIORBODYWORK];
  const questionsAndAnswers = useSelector(getQuestionsAndAnswers);
  const answer = questionsAndAnswers && questionsAndAnswers[QUESTION_ID];
  const factualQuestion = useSelector(getQuestionById("Factual", QUESTION_ID));
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    pageTitle
  } = questionPresentationContent[QUESTION_ID];

  const handleSubmit = (answer: string | null) => {
    if (!answer) {
      return dispatch(appraisalSlice.actions.setQuestionValidation("radio"));
    }
    
    sendEvent("event", "interaction", {
      action: factualQuestion.content,
      label: setAnalyticsLabel(factualQuestion, answer[0]),
    });

    navigate(`/${NEXT_QUESTION_PATH}`);
  };

  return {
    question: factualQuestion,
    questionTitle: factualQuestion.content,
    pageTitle,
    handleSubmit,
    answer
  };
}

export default useTaxi;
